<template>
    <div class="no-permission text-center">
        <font-awesome-icon v-if="icon" :icon="icon" size="lg" />
        <h5> {{ i18n.t('permissions.unpermission.title') }} </h5>
        <p>{{ i18n.t('permissions.unpermission.text') }}</p>
    </div>
</template>
<script setup>
import i18n from "@/i18n/index"
</script>
<style>
.no-permission {
    color: red;
}
</style>